module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-36.562b16af.png";